import React from 'react';
import Icon from '../AppIcon';

const QuickActionToolbar = ({ actions = [], userRole = 'admin' }) => {
  const defaultActions = [
    {
      label: 'إضافة خاصية جديدة',
      icon: 'PlusCircle',
      onClick: () => console.log('Add new property'),
      roles: ['admin', 'property_manager'],
      variant: 'primary',
    },
    {
      label: 'إضافة عميل',
      icon: 'UserPlus',
      onClick: () => console.log('Add new client'),
      roles: ['admin', 'property_manager', 'client_manager'],
      variant: 'default',
    },
    {
      label: 'إنشاء عقد',
      icon: 'FileText',
      onClick: () => console.log('Create contract'),
      roles: ['admin', 'contract_specialist'],
      variant: 'default',
    },
    {
      label: 'تصدير البيانات',
      icon: 'Download',
      onClick: () => console.log('Export data'),
      roles: ['admin'],
      variant: 'default',
    },
    {
      label: 'إرسال رسالة جماعية',
      icon: 'Send',
      onClick: () => console.log('Send bulk message'),
      roles: ['admin', 'client_manager'],
      variant: 'default',
    },
  ];

  const toolbarActions = actions?.length > 0 ? actions : defaultActions;

  const filteredActions = toolbarActions?.filter(action => 
    action?.roles?.includes(userRole)
  );

  if (filteredActions?.length === 0) {
    return null;
  }

  const action1 = filteredActions?.[0];
  const action2 = filteredActions?.[1];
  const action3 = filteredActions?.[2];
  const action4 = filteredActions?.[3];
  const action5 = filteredActions?.[4];

  return (
    <div className="quick-action-toolbar" role="toolbar" aria-label="إجراءات سريعة">
      {action1 && (
        <button
          onClick={action1?.onClick}
          className="quick-action-button"
          aria-label={action1?.label}
        >
          <Icon name={action1?.icon} size={18} />
          <span className="hidden md:inline">{action1?.label}</span>
        </button>
      )}
      {action2 && (
        <button
          onClick={action2?.onClick}
          className="quick-action-button"
          aria-label={action2?.label}
        >
          <Icon name={action2?.icon} size={18} />
          <span className="hidden md:inline">{action2?.label}</span>
        </button>
      )}
      {action3 && (
        <button
          onClick={action3?.onClick}
          className="quick-action-button"
          aria-label={action3?.label}
        >
          <Icon name={action3?.icon} size={18} />
          <span className="hidden md:inline">{action3?.label}</span>
        </button>
      )}
      {action4 && (
        <button
          onClick={action4?.onClick}
          className="quick-action-button"
          aria-label={action4?.label}
        >
          <Icon name={action4?.icon} size={18} />
          <span className="hidden md:inline">{action4?.label}</span>
        </button>
      )}
      {action5 && (
        <button
          onClick={action5?.onClick}
          className="quick-action-button"
          aria-label={action5?.label}
        >
          <Icon name={action5?.icon} size={18} />
          <span className="hidden md:inline">{action5?.label}</span>
        </button>
      )}
    </div>
  );
};

export default QuickActionToolbar;